module.exports = __webpack_public_path__ + "img/c01_unitscout_Normal_ua.10afa617.webp";